export default __webpack_public_path__ + "static/media/hht2_ep9_speaking_03.d2d4d250.png";